export function redirectBasename(): void{
    if ( typeof BASENAME === 'string' ){
        if ( !window.location.pathname.startsWith( BASENAME ) ){
            window.location.pathname = `${BASENAME}${window.location.pathname}`
        }
    }
}